import { useQuery } from "@tanstack/react-query";
import axios, { AxiosError, thrownResponse } from "axios_config";
import { IStation, IChart } from "./interface";

const findRecordWithMaxDataCount = (records: IStation[]) => {
  let maxCountRecord = records[0];
  let maxCount = records[0].data.length;

  for (let i = 1; i < records.length; i++) {
    const currentCount = records[i].data.length;
    if (currentCount > maxCount) {
      maxCount = currentCount;
      maxCountRecord = records[i];
    }
  }
  const data = maxCountRecord.data.map((v) => {
    return v.date_time;
  });
  return data;
};

const createChartValue = (initialStation: any[], stationData: any[]) => {
  const result = initialStation.map((date) => {
    let value = null;
    stationData.forEach((v) => {
      if (v.date_time === date) {
        value = v.avg_corr;
        return;
      }
    });
    return value;
  });
  return result;
};

export const useGetForbush = () => {
  return useQuery<{ stations: IStation[]; chart: IChart[] } | undefined, AxiosError>(["get-forbush"], async () => {
    const res = await axios.get(`/get-all-data-for-graph`);
    if (res.status >= 200 && res.status < 300 && typeof res.data?.result) {
      if (typeof res.data.result === "undefined") {
        return { stations: [], chart: [] };
      } else {
        const stations = res.data.result.map((v: any) => {
          const count_rate = typeof v.count_rate === "number" ? v.count_rate : false;
          const count_rate_reference = typeof v.count_rate_reference === "number" ? v.count_rate_reference : false;
          let change_percentage = 0;
          if (count_rate && count_rate_reference) {
            change_percentage = (100 * (count_rate - count_rate_reference)) / count_rate_reference;
          }
          return {
            ...v,
            lat: (typeof v.lat === "string" || typeof v.lat === "number") && v.lat !== "N/A" ? parseFloat(v.lat) : 0,
            lng: (typeof v.lng === "string" || typeof v.lng === "number") && v.lng !== "N/A" ? parseFloat(v.lng) : 0,
            count_rate: count_rate,
            count_rate_reference: count_rate_reference,
            change_percentage: v.change_percentage,
            change_percentage_backup: change_percentage, //ใช้เพื่อเช็คว่าฝั่ง api คำนวณถูกหรือไม่
            alert: v.alert,
            alert_backup: change_percentage > 3 && v.kp_index > 5 ? true : false, //ใช้เพื่อเช็คว่าฝั่ง api คำนวณถูกหรือไม่
          };
        });

        if (stations && stations.length > 0) {
          // const x = findRecordWithMaxDataCount(stations);
          // const chartData: IChart[] = stations.map((station: IStation) => {
          //   const y = createChartValue(x, station.data);
          //   const res: IChart = {
          //     line: { width: 2 },
          //     name: station.name,
          //     type: "scatter",
          //     x: x,
          //     y: y,
          //   };
          //   return res;
          // });
          // return { stations: stations, chart: chartData };
          return {
            stations: stations,
            chart: [],
          };
        } else {
          return { stations: [], chart: [] };
        }
      }
    } else {
      thrownResponse(res);
    }
  });
};
